import { defineStore } from 'pinia';
import { creditCosts } from '@/Config/PricingConfig';

export const useCreditStore = defineStore({
    id: 'main',
    state: () => ({
        currentBalance: localStorage.getItem('currentBalance') || 0,
        maxBalance: localStorage.getItem('maxBalance') || 0,
        unlimited: (localStorage.getItem('creditUnlimited') || false) === 'true',
        nextResetDate: localStorage.getItem('creditResetDate') || null,
        costs: creditCosts,
    }),
    getters: {
        getCurrentBalance: (state) => {
            return state.currentBalance;
        },
        getMaxBalance: (state) => {
            return state.maxBalance;
        },
        getUnlimited: (state) => {
            return state.unlimited;
        },
        canAfford: (state) => (actionType) => {
            if (state.unlimited) return true;
            const cost = state.costs[actionType] || 1;
            return state.currentBalance >= cost;
        },
        getCost: (state) => (actionType) => state.costs[actionType] || 1,
    },
    actions: {
        setCurrentBalance(newBalance) {
            this.currentBalance = newBalance;
            localStorage.setItem('currentBalance', newBalance);
        },
        setMaxBalance(maxBalance) {
            this.maxBalance = maxBalance;
            localStorage.setItem('maxBalance', maxBalance);
        },
        setUnlimitedCredit(unlimited) {
            this.unlimited = unlimited;
            localStorage.setItem('creditUnlimited', unlimited);
        },
        setNextResetDate(date) {
            this.nextResetDate = date;
            localStorage.setItem('creditResetDate', date);
        },
        clearCreditStore() {
            this.currentBalance = 0;
            this.maxBalance = 0;
            this.unlimited = false;
            this.nextResetDate = null;
            localStorage.removeItem('currentBalance');
            localStorage.removeItem('maxBalance');
            localStorage.removeItem('creditUnlimited');
            localStorage.removeItem('creditResetDate');
        },
    },
});
